import React from 'react'
import Link from 'gatsby-link'


import styled from "styled-components";

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Nav = styled.nav`
  max-width: 600px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
`;

const Logo = styled.div`
  font-family: 'Helvetica Neue';
`;

const Header = ({ siteTitle }) => (
  <HeaderContainer className="header-container">
    <Logo className="header-container--logo">
      W
    </Logo>
    <Nav className="header-container--navigation">
      <Link to="/work">Work</Link>
      <Link to="/about">About</Link>
    </Nav>
  </HeaderContainer>
)

export { Header }



// WEBPACK FOOTER //
// ./src/components/Header/Header.js